/**
 * Formatea bytes a una unidad legible (KB, MB, GB, etc.)
 * @param bytes - Cantidad en bytes
 * @param decimals - Número de decimales a mostrar (default: 2)
 * @returns String formateado con la unidad apropiada
 */
export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return "0 Bytes";
  if (bytes < 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

/**
 * Formatea megabytes a una unidad legible (MB o GB)
 * Usa divisor de 1000 (estándar decimal comercial) donde 1 GB = 1000 MB
 * @param mb - Cantidad en megabytes
 * @param decimals - Número de decimales a mostrar (default: 0)
 * @returns String formateado con la unidad apropiada
 */
export function formatMegabytes(mb: number, decimals: number = 0): string {
  if (mb === 0) return "0 MB";
  if (mb < 0) return "0 MB";

  // Si es menor a 1000 MB, mostrar en MB
  if (mb < 1000) {
    return `${mb.toFixed(decimals)} MB`;
  }

  // Convertir a GB usando estándar decimal (1 GB = 1000 MB)
  const gb = mb / 1000;
  return `${gb.toFixed(decimals)} GB`;
}
